// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AdZ4","right":"styles_right__3DUy0"};